// extracted by mini-css-extract-plugin
module.exports = {"customer-links":"ButtonsRow_customer-links__5rR4L","ButtonsRow":"ButtonsRow_ButtonsRow__Eydzy","button-grid":"ButtonsRow_button-grid___8rQO"};